
export const selectMapElements = () => {
    return {
        mapField: document.querySelector('div#map-field'),
        map: document.querySelector('div#map'),
        mapContainer: document.querySelector('div#map-container')
    };
};
